var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.loading,"z-index":9999}},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading_center"},[_c('div',{staticClass:"lottie_svg"},[_c('div',{ref:"lottie",staticClass:"item-img"})]),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }